import { render, staticRenderFns } from "./Variant.vue?vue&type=template&id=226bb27c"
import script from "./Variant.vue?vue&type=script&lang=js"
export * from "./Variant.vue?vue&type=script&lang=js"
import style0 from "./Variant.vue?vue&type=style&index=0&id=226bb27c&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports